module.exports = __webpack_public_path__ + "529401cd195b90c50d95815d61bc9aaa.svg";